export const es_28 = {
    "common": {
        "plan": "Paquetes",
    }
}